export const CONFIG = {
	TITLE: "Aranzazu Gutierrez Butler",
	DESCRIPTION:
		"Trabajadora social, escritora, conferenciante y activista. Autora de 'Todo lo que no ves' y fundadora de la Asociación Equilibrio.",
	AUTHOR: "Aranzazu Gutierrez Butler",
	VERSION: "1.0.0",
	LOGO: "/api/og?type=default", // Tarjeta OG dinámica (Sharp). Ver lib/og + app/api/og
	URL: process.env.NEXT_PUBLIC_URL || "https://aranzazugbutler.com",
	CONTACT_EMAIL: "aran.gb@gmail.com",
	CONTACT_PHONE: "+34 687 637 098",
	CONTACT_ADDRESS: "Las Palmas de Gran Canaria, España",
	ENTERPRISE_NAME: "ARANZAZU GUTIERREZ BUTLER",
	// Remitente verificado en Resend para los correos transaccionales del formulario.
	// TODO: pasar a no-reply@aranzazugbutler.com cuando el dominio esté
	// verificado en Resend (hasta entonces Resend rechazaría los envíos).
	EMAIL_FROM: "Asociación Equilibrio <no-reply@asociacion-equilibrio.es>",
	// Información de la asociación (para la página interna)
	ASSOCIATION: {
		TITLE: "Asociación Equilibrio",
		DESCRIPTION: "Comprometida con el bienestar social y comunitario.",
		EMAIL: "asociacionequilibrio.if@gmail.com",
		ADDRESS:
			"Calle de la Constitución, 123, 35001, Las Palmas de Gran Canaria, España",
		ENTERPRISE_NAME: "ASOCIACIÓN EQUILIBRIO PARA EL BIENESTAR SOCIAL",
	},
} as const;
